// Enforce minimum order value on cart page & cart drawer
document.addEventListener('DOMContentLoaded', () => {
  // Set your minimum here (in pence/cents)
  const MIN_CENTS = 2000; // £20.00
  const CURRENCY = 'GBP';

  const money = (cents) =>
    (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: CURRENCY });

  const findCheckoutButtons = () => [
    ...document.querySelectorAll('button[name="checkout"]'),
    ...document.querySelectorAll('.cart__checkout-button'),
    ...document.querySelectorAll('[data-cart-checkout-button]'),
    ...document.querySelectorAll('.shopify-payment-button button'),          // dynamic buttons
    ...document.querySelectorAll('.shopify-payment-button__button'),        // fallback
  ];

  const findDrawer = () =>
    document.querySelector('cart-drawer, .drawer, .cart-drawer, #CartDrawer') || null;

  const ensureMessage = (container) => {
    let p = container.querySelector('#min-order-msg');
    if (!p) {
      p = document.createElement('p');
      p.id = 'min-order-msg';
      p.setAttribute('role', 'status');
      p.style.margin = '0 0 0.75rem 0';
      p.style.fontSize = '0.95rem';
      p.style.color = 'var(--color-foreground, #c00)';
      container.prepend(p);
    }
    return p;
  };

  const updateUI = (subtotalCents) => {
    const allowed = subtotalCents >= MIN_CENTS;

    // Buttons (checkout + dynamic) enabled/disabled
    const btns = findCheckoutButtons();
    btns.forEach((b) => {
      try {
        b.disabled = !allowed;
        // Also hide accelerated checkout if not allowed
        if (b.closest('.shopify-payment-button')) {
          b.closest('.shopify-payment-button').style.display = allowed ? '' : 'none';
        }
      } catch (e) {}
    });

    // Message on cart page
    const form = document.querySelector('form[action="/cart"]') || document;
    const msg = ensureMessage(form);
    if (!allowed) {
      const diff = MIN_CENTS - subtotalCents;
      msg.textContent = `Minimum order is ${money(MIN_CENTS)}. Add ${money(diff)} more to checkout.`;
      msg.style.display = '';
    } else {
      msg.textContent = '';
      msg.style.display = 'none';
    }

    // Message in cart drawer (if present)
    const drawer = findDrawer();
    if (drawer) {
      const footer = drawer.querySelector('.cart-drawer__footer, footer, form[action="/cart"]') || drawer;
      const dMsg = ensureMessage(footer);
      if (!allowed) {
        const diff = MIN_CENTS - subtotalCents;
        dMsg.textContent = `Minimum order is ${money(MIN_CENTS)}. Add ${money(diff)} more to checkout.`;
        dMsg.style.display = '';
      } else {
        dMsg.textContent = '';
        dMsg.style.display = 'none';
      }
    }
  };

  // Read subtotal from /cart.js (reliable across themes)
  const refreshFromCart = () =>
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        // Use items_subtotal_price (pre-shipping, pre-tax; discounts already applied)
        updateUI(cart.items_subtotal_price ?? 0);
      })
      .catch(() => { /* ignore */ });

  // Initial run
  refreshFromCart();

  // Re-run when quantities change or drawer updates
  const debounced = (() => {
    let t;
    return () => { clearTimeout(t); t = setTimeout(refreshFromCart, 200); };
  })();

  // Common events that reflect cart changes
  document.addEventListener('change', (e) => {
    if (e.target.closest('cart-items, form[action="/cart"], .cart-drawer')) debounced();
  });
  document.addEventListener('cart:updated', debounced);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[name="update"], [data-cart-update], .quantity__button')) debounced();
  });

  // Observe dynamic cart drawer DOM changes
  const drawer = findDrawer();
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(debounced).observe(drawer, { childList: true, subtree: true });
  }
});